import { css } from '@emotion/react/macro';
import styled from '@emotion/styled/macro';
import { Variables } from '@enter/core';
import { Icon } from '@mdi/react';

interface ISelectableProps {
    selectable: boolean;
}

export const Selectable = (props: ISelectableProps) => css`
    display: flex;
    flex-direction: column;
    justify-content: flex-start;
    align-items: flex-start;
    flex-grow: 1;

    cursor: ${props.selectable ? 'pointer' : 'default'};
    padding: 16px;
`;

export const SelectableDiv = styled.div<ISelectableProps>`
    ${Selectable};
`;

export const StyledIcon = styled(Icon)`
    margin-top: 4px;
    height: 16px;
    width: 16px;
    fill: ${Variables.Colors.b300};
    align-self: center;
`;

export const Expand = styled.div`
    display: flex;
    flex-direction: row;
    align-items: stretch;
    padding: 0;
`;

export const ExpandTable = styled.table`
    white-space: normal;
    color: ${Variables.Colors.n100};
    padding: 16px 24px;
    width: auto;
    margin: 0 24px 24px 24px;
`;
export const ExpandTBody = styled.tbody`
    padding-top: 16px;
`;
export const ExpandTR = styled.tr``;
export const ExpandTH = styled.th`
    text-align: left;
    vertical-align: top;
    padding-right: 1em;
    font-weight: 500;
    white-space: nowrap;
`;
export const ExpandTD = styled.td``;
export const ExpandTitle = styled.h3`
    margin: 18px 0 0 0;
    font-weight: 500;
    font-size: 16px;
    text-decoration: underline;
`;
